export default {
  de: {
    true: 'Ja',
    false: 'Nein',
    numbers: 'Summe',
  },
};
